import PropTypes from 'prop-types';
// @mui
import {
  Stack,
  Avatar,
  TableRow,
  TableCell,
  Typography,
  Collapse,
  IconButton,
  Box,
  CircularProgress,
} from '@mui/material';
// sections
import ProgrammeListPage from '../../../pages/admin/ProgrammeListPage';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

UserTableRow.propTypes = {
  row: PropTypes.oneOfType([PropTypes.array, PropTypes.number, PropTypes.object]),
  selected: PropTypes.bool,
  programmeList: PropTypes.array,
  openRow: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  handleToggle: PropTypes.func.isRequired,
};

const removeDuplicates = (data) => {
  const unique = new Map();
  data.forEach((item) => {
    if (!unique.has(item.UserID)) {
      unique.set(item.UserID, item);
    }
  });
  return Array.from(unique.values());
};

export default function UserTableRow({ row, selected, programmeList, openRow, handleToggle }) {
  const openCollapse = openRow === (Array.isArray(row) ? row[0]?.UserID : row?.UserID);

  const renderRow = (data) => (
    <TableRow
      hover
      selected={selected}
      key={data.UserID}
      sx={{
        backgroundColor: openCollapse ? '#fcfcfc' : 'inherit',
        borderTop: openCollapse ? '1px solid rgb(0, 0, 0, 0.05)' : 'none',
      }}
    >
      <TableCell>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar alt={`${data.FirstName} ${data.LastName}`} src={data.UserProfileImage} />
          <Typography variant="subtitle2" sx={{ wordBreak: 'break-word' }}>
            {`${data.FirstName === 'undefined' ? '' : data.FirstName} ${data.LastName === 'undefined' ? '' : data.LastName}`}
          </Typography>
        </Stack>
      </TableCell>

      <TableCell align="left">
        {data.UserEmailAddress && <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>{data.UserEmailAddress}</Typography>}
        {data.UserContactNo && <Typography variant="body2" noWrap>{data.UserContactNo}</Typography>}
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2" noWrap>{data.GrandTotal || '-'}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2" noWrap>{data.FeePaid}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2" noWrap>{data.CertificateAward || '-'}</Typography>
      </TableCell>

      <TableCell align="center">
        <IconButton onClick={() => handleToggle(data.UserID)}>
          {openCollapse ? <Iconify icon="carbon:chevron-up" /> : <Iconify icon="carbon:chevron-down" />}
        </IconButton>
      </TableCell>
    </TableRow>
  );

  const processedRow = Array.isArray(row) ? removeDuplicates(row) : [row];

  return (
    <>
      {row.UserTypeID !== 1 &&
        <>
          {processedRow.map((prog) => renderRow(prog))}

          <TableRow>
            <TableCell colSpan={6} sx={{ p: 0, backgroundColor: openCollapse ? '#fcfcfc' : 'inherit' }}>
              <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                <Box margin={{ xs: 0, md: 1 }} display="flex" justifyContent="center" alignItems="center">
                  {row.isLoading ? (
                    <CircularProgress />
                  ) : (
                    <ProgrammeListPage
                      row={row}
                      selected={selected}
                      programmeList={programmeList}
                    />
                  )}
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      }
    </>
  );
}
